/**
 * @file Input component for string input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { Renderer, ElementRef } from '@angular/core';
import { UploadInput } from '../../../base/inputs/input-upload/input-upload.component';
import { ImageService } from '../../../base/image.service';
import { AlertsService } from '../../../core/alerts.service';
/**
 * Class for the image input component
 */
var InputImageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputImageComponent, _super);
    /**
     * Constructs a InputImageComponent.
     * @param renderer Render used to perform action in DOM
     * @param alertsService Service for giving user feedback
     */
    function InputImageComponent(renderer, alertsService, imageService) {
        var _this = _super.call(this, alertsService, imageService) || this;
        _this.renderer = renderer;
        _this.alertsService = alertsService;
        _this.imageService = imageService;
        // We can use value instead of imageUrl
        _this.imageUrl = '';
        return _this;
    }
    /**
     * Open the file dialog
     */
    InputImageComponent.prototype.openFileDialog = function () {
        this.renderer.invokeElementMethod(this.inputImage.nativeElement, 'click', []);
    };
    /**
     * Open the file dialog
     * @return Returns true if image exist
     */
    InputImageComponent.prototype.hasImage = function () {
        // TODO: Check something with file value? (set true after uploading, file url (in this.value) must exist!)
        return true;
    };
    /**
     * Get the image
     * @return Returns a promise with the path to the image
     */
    InputImageComponent.prototype.getImageUrl = function (entity) {
        var _this = this;
        // was used in template, template now uses imageUrl
        return new Promise(function (resolve, reject) {
            // TODO: return path based on value?
            return _this.imageService.getFile(undefined).then(function (upload) {
                resolve(upload.url);
            });
        });
    };
    /**
     * Delete the image
     */
    InputImageComponent.prototype.deleteImage = function () {
        this.imageService.deleteUpload(undefined, undefined);
    };
    return InputImageComponent;
}(UploadInput));
export { InputImageComponent };
